/* The Mad Nose, EDP product page behaviour */
(function () {
  if (window.__tmnPdpLoaded) return;
  window.__tmnPdpLoaded = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initBuybox(box) {
    var picker = box.querySelector('[data-tmn-picker]');
    var grid = picker ? picker.querySelector('fieldset') : null;
    var toggle = box.querySelector('[data-tmn-toggle]');
    var toggleLabel = box.querySelector('[data-tmn-toggle-label]');
    var nameEl = box.querySelector('[data-tmn-second-name]');
    var pairsEl = box.querySelector('[data-tmn-pairs]');
    var ctaPrices = box.querySelectorAll('[data-tmn-cta-price]');
    var status = box.querySelector('[data-tmn-status]');
    var buttons = box.querySelectorAll('[data-tmn-add]');
    var mainId = Number(box.dataset.variantId);

    function pack() {
      var el = box.querySelector('input[data-tmn-pack]:checked');
      return el ? el.value : 'single';
    }
    function second() {
      return box.querySelector('input[data-tmn-second]:checked');
    }

    function setGrid(open) {
      if (!grid || !toggle) return;
      grid.hidden = !open;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (toggleLabel) toggleLabel.textContent = open ? 'Close' : 'Change';
    }

    function update() {
      var isDuo = pack() === 'duo';
      if (picker) picker.hidden = !isDuo;
      if (!isDuo) setGrid(false);
      var price = isDuo ? box.dataset.priceDuo : box.dataset.priceSingle;
      ctaPrices.forEach(function (el) { el.textContent = price; });
      var s = second();
      if (s && nameEl) nameEl.textContent = s.dataset.name;
      if (pairsEl) pairsEl.hidden = !(s && s.hasAttribute('data-pairs'));
      if (status) status.textContent = '';
    }

    function buildItems() {
      if (pack() !== 'duo') return [{ id: mainId, quantity: 1 }];
      var s = second();
      if (!s) return null;
      if (s.value === 'same') return [{ id: mainId, quantity: 2 }];
      return [{ id: mainId, quantity: 1 }, { id: Number(s.value), quantity: 1 }];
    }

    function setBusy(busy, btn, label) {
      buttons.forEach(function (b) { b.disabled = busy; });
      if (btn && label) btn.innerHTML = label;
    }

    function add(btn) {
      var items = buildItems();
      if (!items) {
        status.textContent = 'Pick your 2nd scent to continue.';
        setGrid(true);
        return;
      }
      var original = btn.innerHTML;
      setBusy(true, btn, 'Adding...');
      status.textContent = '';

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) throw new Error(data.description || data.message || 'This item could not be added');
            return data;
          });
        })
        .then(function (data) {
          document.dispatchEvent(new CustomEvent('tmn:cart:added', { detail: { items: items, response: data } }));
          window.location.href = btn.dataset.tmnAdd === 'checkout' ? root + 'checkout' : (box.dataset.cartUrl || root + 'cart');
        })
        .catch(function (err) {
          status.textContent = err.message + '. Please try again.';
          setBusy(false, btn, original);
        });
    }

    if (toggle) {
      toggle.addEventListener('click', function () { setGrid(grid.hidden); });
    }
    box.addEventListener('change', function (e) {
      update();
      if (e.target && e.target.hasAttribute('data-tmn-second')) {
        setGrid(false);
        if (toggle) toggle.focus({ preventScroll: true });
      }
    });
       buttons.forEach(function (btn) {
      btn.addEventListener('click', function () { add(btn); });
    });

    /* Sticky add to cart: shows only when the main button is scrolled past */
    var sticky = box.querySelector('[data-tmn-sticky]');
    var mainCta = box.querySelector('.tmn-cta [data-tmn-add]');
    function syncSticky() {
      if (!sticky) return;
      var label = sticky.querySelector('[data-tmn-sticky-label]');
      var short = sticky.dataset.short || '';
      var s = second();
      if (!label) return;
      if (pack() !== 'duo' || !s) label.textContent = short + ', 1 bottle';
      else if (s.value === 'same') label.textContent = short + ' x2';
      else label.textContent = short + ' + ' + s.dataset.name;
    }
    if (sticky && mainCta && 'IntersectionObserver' in window) {
      sticky.hidden = false;
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var passed = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', passed);
      }).observe(mainCta);
      var change = sticky.querySelector('[data-tmn-sticky-change]');
      if (change) change.addEventListener('click', function () {
        var target = box.querySelector('.tmn-pack') || box;
        target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      });
      box.addEventListener('change', syncSticky);
    }
    syncSticky();
    update();
  }

  function initTabs(tabs) {
    var btns = Array.prototype.slice.call(tabs.querySelectorAll('[role="tab"]'));
    function select(i, focus) {
      btns.forEach(function (b, j) {
        var on = j === i;
        b.setAttribute('aria-selected', on ? 'true' : 'false');
        b.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(b.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) btns[i].focus();
    }
    btns.forEach(function (b, i) {
      b.addEventListener('click', function () { select(i, false); });
      b.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); select((i + 1) % btns.length, true); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); select((i - 1 + btns.length) % btns.length, true); }
      });
    });
  }

  /* "Add as 2nd bottle" on the scent cards: switch the buy box to 2 bottles,
     select that scent, and scroll back up to the buy buttons. */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-tmn-pick-second]');
    if (!trigger) return;
    var box = document.querySelector('[data-tmn-buybox]');
    if (!box) return;
    var duo = box.querySelector('input[data-tmn-pack][value="duo"]');
    if (duo) duo.checked = true;
    var opt = box.querySelector('input[data-tmn-second][value="' + trigger.dataset.tmnPickSecond + '"]');
    if (opt) opt.checked = true;
    box.dispatchEvent(new Event('change', { bubbles: true }));
    var target = box.querySelector('[data-tmn-toggle]') || box;
    target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
    if (target.focus) target.focus({ preventScroll: true });
  });

  /* Tap to copy discount code */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-tmn-copy]');
    if (!btn) return;
    var code = btn.dataset.tmnCopy;
    var label = btn.querySelector('[data-tmn-copy-label]') || btn;
    function done() {
      btn.classList.add('is-copied');
      label.textContent = 'Copied!';
      setTimeout(function () { btn.classList.remove('is-copied'); label.textContent = code; }, 2000);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done, done);
    } else {
      var t = document.createElement('textarea');
      t.value = code; t.setAttribute('readonly', ''); t.style.position = 'absolute'; t.style.left = '-9999px';
      document.body.appendChild(t); t.select();
      try { document.execCommand('copy'); } catch (err) {}
      document.body.removeChild(t); done();
    }
  });

  /* UGC reels: autoplay muted in view, tap anywhere to toggle sound, one sound at a time */
  function initReels(track) {
    var section = track.closest('.tmn-reels');
    var reels = Array.prototype.slice.call(track.querySelectorAll('.tmn-reel'));
    var items = reels.map(function (reel) {
      var v = reel.querySelector('video');
      var btn = reel.querySelector('[data-tmn-reel-toggle]');
      var bar = reel.querySelector('[data-tmn-reel-bar]');
      if (!v || !btn) return null;
      v.muted = true; v.loop = true; v.playsInline = true;
      v.setAttribute('playsinline', ''); v.removeAttribute('controls'); v.removeAttribute('autoplay');
      if (bar) {
        v.addEventListener('timeupdate', function () {
          if (v.duration) bar.style.transform = 'scaleX(' + (v.currentTime / v.duration) + ')';
        });
      }
      return { reel: reel, v: v, btn: btn };
    }).filter(Boolean);

    function setSound(item, on) {
      item.v.muted = !on;
      item.reel.classList.toggle('is-sound', on);
      item.btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var name = item.btn.dataset.name || 'this';
      item.btn.setAttribute('aria-label', (on ? 'Turn sound off for ' : 'Turn sound on for ') + name + "'s video");
    }

    items.forEach(function (item) {
      item.btn.addEventListener('click', function () {
        var turnOn = item.v.muted || item.v.paused;
        items.forEach(function (other) { if (other !== item) setSound(other, false); });
        setSound(item, turnOn);
        if (turnOn) {
          if (section) section.classList.add('has-heard');
          var p = item.v.play(); if (p && p.catch) p.catch(function () {});
        }
      });
    });

    if ('IntersectionObserver' in window && !reduceMotion) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var item = items.filter(function (i) { return i.reel === e.target; })[0];
          if (!item) return;
          if (e.isIntersecting && e.intersectionRatio >= 0.6) {
            var p = item.v.play(); if (p && p.catch) p.catch(function () {});
          } else {
            item.v.pause();
            if (!item.v.muted) setSound(item, false);
          }
        });
      }, { threshold: [0, 0.6] });
      items.forEach(function (i) { io.observe(i.reel); });
    }

    var prevs = section ? Array.prototype.slice.call(section.querySelectorAll('[data-tmn-reels-prev]')) : [];
    var nexts = section ? Array.prototype.slice.call(section.querySelectorAll('[data-tmn-reels-next]')) : [];
    function step() {
      var first = reels[0];
      return first ? first.getBoundingClientRect().width + 16 : 280;
    }
    function updateArrows() {
      var atStart = track.scrollLeft <= 4;
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      prevs.forEach(function (b) { b.disabled = atStart; });
      nexts.forEach(function (b) { b.disabled = atEnd; });
    }
    var behavior = reduceMotion ? 'auto' : 'smooth';
    prevs.forEach(function (b) { b.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: behavior }); }); });
    nexts.forEach(function (b) { b.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: behavior }); }); });
    window.addEventListener('resize', updateArrows);
    track.addEventListener('scroll', updateArrows, { passive: true });
    updateArrows();
  }
/* Pocket perfume buy box: scent cards, packs (1 / any 2 / all 3), quantity */
  function initCapsule(box) {
    var prices = {
      single: Number(box.dataset.priceSingle),
      pair: Number(box.dataset.pricePair),
      trio: Number(box.dataset.priceTrio)
    };
    var status = box.querySelector('[data-tmn-status]');
    var qtyInput = box.querySelector('[data-tmn-qty-input]');
    var pairBox = box.querySelector('[data-tmn-cap-pair]');
    var singleNote = box.querySelector('[data-tmn-cap-single-note]');
    var priceEls = box.querySelectorAll('[data-tmn-cap-price]');
    var addBtns = Array.prototype.slice.call(box.querySelectorAll('[data-tmn-cap-add]'));
    var cards = Array.prototype.slice.call(box.querySelectorAll('.tmn-scent-card'));
    var sticky = box.querySelector('[data-tmn-sticky]');
    var stickyLabel = box.querySelector('[data-tmn-sticky-label]');

    function fmt(cents) { return '\u20B9' + Math.round(cents / 100).toLocaleString('en-IN'); }
    function pack() { var el = box.querySelector('input[data-tmn-cap-pack]:checked'); return el ? el.value : 'single'; }
    function scent() { return box.querySelector('input[data-tmn-cap-scent]:checked'); }
    function slot(n) { return box.querySelector('input[data-tmn-cap-slot="' + n + '"]:checked'); }
    function qty() {
      var q = parseInt(qtyInput && qtyInput.value, 10);
      if (!q || q < 1) q = 1;
      if (q > 10) q = 10;
      return q;
    }
    function allScents() {
      return Array.prototype.slice.call(box.querySelectorAll('input[data-tmn-cap-scent]')).filter(function (i) { return !i.disabled; });
    }

    function items() {
      var q = qty(), p = pack(), map = {};
      function put(id) { map[id] = (map[id] || 0) + q; }
      if (p === 'single') { var s = scent(); if (!s) return null; put(s.value); }
      else if (p === 'pair') { var a = slot(1), b = slot(2); if (!a || !b) return null; put(a.value); put(b.value); }
      else { allScents().forEach(function (i) { put(i.value); }); }
      return Object.keys(map).map(function (id) { return { id: Number(id), quantity: map[id] }; });
    }

    function summary() {
      var p = pack(), q = qty(), text;
      if (p === 'single') { var s = scent(); text = s ? s.dataset.name : 'Pick a scent'; }
      else if (p === 'pair') {
        var a = slot(1), b = slot(2);
        text = a && b ? (a.value === b.value ? a.dataset.name + ' x2' : a.dataset.name + ' + ' + b.dataset.name) : 'Pick 2 tins';
      } else { text = 'All 3 scents'; }
      return q > 1 ? text + ' (' + q + ' packs)' : text;
    }

    function update() {
      var p = pack();
      if (pairBox) pairBox.hidden = p !== 'pair';
      var s = scent();
           if (singleNote && s) singleNote.textContent = s.dataset.name + ' \u00B7 ' + (singleNote.dataset.wear || '');
      var total = (prices[p] || 0) * qty();
      priceEls.forEach(function (el) { el.textContent = fmt(total); });
      if (stickyLabel) stickyLabel.textContent = summary();
      if (status) status.textContent = '';
    }

    box.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches && t.matches('[data-tmn-cap-scent]')) {
        var s1 = box.querySelector('input[data-tmn-cap-slot="1"][value="' + t.value + '"]');
        if (s1 && !s1.disabled) s1.checked = true;
                showInfo(t);
      }
      if (t === qtyInput) qtyInput.value = qty();
      update();
    });

    box.querySelectorAll('[data-tmn-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        qtyInput.value = Math.min(10, Math.max(1, qty() + Number(b.dataset.tmnQty)));
        update();
      });
    });

        /* Scent info panel: shows the hovered (desktop) or selected scent */
    var infoName = box.querySelector('[data-tmn-info-name]');
    var infoSmells = box.querySelector('[data-tmn-info-smells]');
    var infoFeels = box.querySelector('[data-tmn-info-feels]');
    var smellsRow = box.querySelector('[data-tmn-info-smells-row]');
    var feelsRow = box.querySelector('[data-tmn-info-feels-row]');
    function showInfo(input) {
      if (!input) return;
      if (infoName) infoName.textContent = input.dataset.name;
      if (infoSmells) infoSmells.textContent = input.dataset.smells || '';
      if (infoFeels) infoFeels.textContent = input.dataset.feels || '';
      if (smellsRow) smellsRow.hidden = !input.dataset.smells;
      if (feelsRow) feelsRow.hidden = !input.dataset.feels;
    }
    cards.forEach(function (card) {
      var input = card.querySelector('input');
      card.addEventListener('mouseenter', function () { showInfo(input); });
      card.addEventListener('mouseleave', function () { showInfo(scent()); });
    });

    function add(btn) {
      var list = items();
      if (!list || !list.length) { status.textContent = 'Pick your scents to continue.'; return; }
      var original = btn.innerHTML;
      addBtns.forEach(function (b) { b.disabled = true; });
      btn.textContent = 'Adding...';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: list })
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) throw new Error(data.description || data.message || 'This item could not be added');
            return data;
          });
        })
        .then(function (data) {
          document.dispatchEvent(new CustomEvent('tmn:cart:added', { detail: { items: list, response: data } }));
          window.location.href = box.dataset.cartUrl || root + 'cart';
        })
        .catch(function (err) {
          status.textContent = err.message + '. Please try again.';
          btn.innerHTML = original;
          addBtns.forEach(function (b) { b.disabled = false; });
        });
    }
    addBtns.forEach(function (b) { b.addEventListener('click', function () { add(b); }); });

    var mainBtn = box.querySelector('.tmn-cta [data-tmn-cap-add]');
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      sticky.hidden = false;
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(mainBtn);
      var change = sticky.querySelector('[data-tmn-sticky-change]');
      if (change) change.addEventListener('click', function () {
        var target = box.querySelector('.tmn-scents') || box;
        target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      });
    }
    update();
  }
  
  
  function init() {
    document.querySelectorAll('[data-tmn-buybox]').forEach(initBuybox);
    document.querySelectorAll('[data-tmn-tabs]').forEach(initTabs);
    document.querySelectorAll('[data-tmn-reels]').forEach(initReels);
        document.querySelectorAll('[data-tmn-capsule]').forEach(initCapsule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

